import * as yup from 'yup'

import { FragmentType, gql, useFragment } from 'graphql-generated'
import { GetText } from 'lib/gettext'

const INTERESTS_FRAGMENT = gql(`
  fragment PublicProfile_Profile_Interests on accounts_profile {
    interests
  }
`)

type InterestsProps = {
  profileRef: FragmentType<typeof INTERESTS_FRAGMENT>
  className?: string
}

export default function Interests(props: InterestsProps) {
  const { interests: json } = useFragment(INTERESTS_FRAGMENT, props.profileRef)

  const interests =
    yup
      .array()
      .of(yup.string().required())
      .notRequired()
      .nullable()
      .validateSync(json) || []

  if (interests.length > 0) {
    return (
      <div className={props.className}>
        <h3 className="mb-2 text-lg font-semibold capitalize">
          <GetText>Research Interests</GetText>
        </h3>

        <ul className="grid grid-cols-2 gap-x-4 gap-y-1 md:grid-cols-3">
          {interests.map((interest) => (
            <li
              className="capitalize before:mr-2 before:text-secondary-light before:content-['—']"
              key={interest}
            >
              {interest}
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return null
}
